import React, {useState} from "react";
import { connect } from 'react-redux'
import stateMap from "store/stateMap";
import api from "api";

import _ from "lodash";
import { Waypoint } from 'react-waypoint';
import update from 'immutability-helper';
import {Talk, TalkForm} from "component/Talk";
import "./index.scss";
import { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import { PageCredential } from "component/PageCredential";


const PageInsideInitiativeTalkSingle = connect(stateMap)((props) => {
    const[talks, setTalks]                              = useState(false);
    const[fetchingTalk, setFetchingTalk]                = useState(false);
    let [searchParams]                                  = useSearchParams();

    useEffect(() => {
        
        setFetchingTalk(true);

        api('/Talk', 'get', {
            id : searchParams.get('id')
        } , 'Bearer ' + props.auth.token)
            .then(response => {
                setFetchingTalk(false);
                
                setTalks(response.talk);
            })
    }, []);

    return (
        <div className="container">
            <div className="w-800 mx-auto">
                <div className="text-right">
                    <Link className="color-orange bold text-sm" to={{
                        pathname : '/initiative/' + props.initiative.initiative.Slug + '/discussion'
                    }}>View All Discussion</Link>
                </div>
                <ul className="talk-lists">
                    {
                        talks !== false && talks.length == 0 && 
                        <li className="talk mt-lg">
                            <span className="block text-center text-lg font-bold">
                                Discussion not found
                            </span>
                        </li>
                    }
                    {
                        talks !== false && talks.map((talk) => (
                            <li className="talk" key={talk.TalkID}>
                                <Talk 
                                    talk={talk} 
                                    initiative={props.initiative.initiative} 
                                    user={props.auth.user} 
                                    userToken={props.auth.token}
                                    autoShowReplies={true}
                                />
                            </li>
                        ))
                        
                    }
                    {
                        fetchingTalk && 
                        (
                            <li className="talk skeleton-talk mt-md">
                            {
                                <span className="skeleton"></span> 
                            }
                            </li>
                        )
                    }
                </ul>
            </div>
        </div>
    )
});

const PageInsideInitiativeTalk = connect(stateMap)((props) => {

    const[talks, setTalks]                              = useState(false);
    const[paged, setPaged]                              = useState(1);
    const[fetchingTalk, setFetchingTalk]                = useState(false);
    const[showCreateForm, setShowCreateForm]            = useState(false);
    let [searchParams]                                  = useSearchParams();
    
    const isDiscussionOpen = () => {
        return (
            props.initiative.initiative.CurrentStatus == 'recruitment'
            ||
            (
                props.initiative.initiative.CurrentStatus != 'recruitment'
                &&
                props.initiative.access
                &&
                props.initiative.access.membership
            )
        )
    }

    const PaginationTalk = () => {

        if(fetchingTalk)
        {
            return;
        }

        if(!props.auth.user)
        {
            return;
        }

        if(!(props.initiative.access.membership || props.initiative.initiative.CurrentStatus == 'recruitment') )
        {
            return;
        }

        setFetchingTalk(true);

        api('/Talk', 'get', {
            paged               : paged
            ,posts_per_page     : 3
            ,parent_talk_id     : 0
            ,initiative_id      : props.initiative.initiative.InitiativeID
        } , 'Bearer ' + props.auth.token)
        .then(function(ResponseTalks){
            
            if(ResponseTalks.talk.length > 0)
            {
                setFetchingTalk(false);

                var NewTalks = _.map(ResponseTalks.talk, function(talk){
                    return talk;
                });

                if(talks !== false)
                {
                    setTalks( talks.concat(NewTalks));
                }
                else
                {
                    setTalks(NewTalks);
                }

                setPaged(paged + 1);

            }
            else
            {
                if(paged == 1)
                {
                    setTalks([]);
                }

                setFetchingTalk('EOF');
            }
        })
    }

    useEffect(PaginationTalk, [props.initiative.access]);


    return (
        <>
            <PageCredential title={`${props.initiative.initiative.Title} | Discussion`}/>
            {
                searchParams.get('id') ?
                <PageInsideInitiativeTalkSingle/> :
                <div className="initiative-talk-container">
                    {
                        props.initiative.access && isDiscussionOpen() &&
                        <div className="w-800 mx-auto container">
                            {
                                talks !== false && isDiscussionOpen() && !showCreateForm &&
                                <div className="page-talk-intro-action rounded bg-white border-solid leading-text text-sm">
                                    {
                                        props.initiative.initiative.CurrentStatus == 'recruitment' 
                                        ? <div>
                                            Discuss various questions regarding this initiative before joining
                                            <br/>
                                            <div className="text-xs leading-tight mt-sm">Discussion Tab open for non-member user only when initiative in recruitment phase</div>
                                        </div> 
                                        : <div>Have a question or something you want to discuss? Discuss with project creators or other collaborators</div> 
                                    }
                                    <button className="btn btn-orange btn-small" style={{display : 'block'}} onClick={(e) => {
                                        e.preventDefault();

                                        setShowCreateForm(true);

                                    }}>Ask Question</button>
                                </div>
                            }
                            {
                                talks !== false && isDiscussionOpen() && showCreateForm &&
                                <TalkForm
                                    initiative={props.initiative.initiative}
                                    userToken={props.auth.token}
                                    user={props.auth.user}
                                    onSave={(talk) => {
                                        setTalks(update(talks, {
                                            $unshift : [talk]
                                        }));

                                        setShowCreateForm(false);
                                    }}
                                    onCancel={() => {
                                        setShowCreateForm(false);
                                    }}
                                />
                            }
                            <div className="font-bold mt-4 mb-sm">Discussion</div>
                            <ul className="talk-lists">
                                {
                                    talks !== false && talks.length == 0 && 
                                    <li className="talk mt-lg">
                                        <span className="block text-center text-lg font-bold">
                                            No discussions at the moment
                                        </span>
                                    </li>
                                }
                                {
                                    talks !== false && talks.map((talk) => {

                                        return (
                                            <li className="talk" key={talk.TalkID}>
                                                <Talk 
                                                    talk={talk} 
                                                    initiative={props.initiative.initiative} 
                                                    user={props.auth.user} 
                                                    userToken={props.auth.token}
                                                />
                                            </li>
                                        )
                                    })
                                }
                                {
                                    fetchingTalk === true && 
                                    <li className="talk skeleton-talk mt-md">
                                    {
                                        fetchingTalk && <span className="skeleton"></span> 
                                    }
                                    </li>
                                }
                                {
                                    fetchingTalk !== 'EOF' && paged > 1 && 
                                    (
                                        <Waypoint onEnter={PaginationTalk}/>
                                    )
                                }
                            </ul>
                            {
                                talks !== false && fetchingTalk !== 'EOF' &&
                                <div className="text-center text-xs mt-md ">
                                    Loading More Discussion...
                                </div>
                            }
                        </div>          
                    }
                </div>
            }
        </>
    );
});

export default PageInsideInitiativeTalk;